import type { PortalUnbilledSummary } from "./database.types"

export function getOpenEndedEngagementLabel(
  status: PortalUnbilledSummary["engagements"][number]["status"]
) {
  return status === "active" ? "Ongoing" : "No end date"
}
